/**
 * AffiliatePasswordResetSuccess — terminal step of the portal's password reset.
 * The reset grants no session, so the affiliate signs in with the new password.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { AffiliatePortalLayout } from '../features/affiliate/AffiliatePortalLayout';
import { AFFILIATE_ROUTES } from '../features/affiliate/affiliateRoutes';
import '../components/layout/authFlow.css';
import '../features/affiliate/affiliatePortal.css';

export function AffiliatePasswordResetSuccess() {
  const { t } = useTranslation();

  return (
    <AffiliatePortalLayout centered>
      <div className="auth-flow__card">
        <h1 className="auth-flow__heading">{t('auth.passwordResetSuccess.heading')}</h1>
        <p className="auth-flow__subheading">
          {t('auth.passwordResetSuccess.subheading')}
        </p>
        <Link
          className="auth-flow__primary auth-flow__primary--link"
          to={AFFILIATE_ROUTES.SIGN_IN}
        >
          {t('auth.passwordResetSuccess.backToSignIn')}
        </Link>
      </div>
    </AffiliatePortalLayout>
  );
}
